import { FC } from "react";
import { useStyle } from "./RegistrationCompleted.styles";
import { AcknowledgementLayout } from "@funded-here-interface/common";

const RegistrationCompleted: FC = () => {
  const { classes } = useStyle();

  return (
    <AcknowledgementLayout
      showLogo={false}
      content={
        <div className={classes.container}>
          <h2 className={classes.header}>Board Resolution Signing Completed</h2>
          <p className={classes.text}>
            The Board Resolution has been successfully signed.
          </p>
          <p className={classes.text}>
            Once all directors of your company have signed the Board Resolution,
            your company's authorized representative will receive an email with
            instructions to complete the e-KYC process and sign the required
            agreement(s).
          </p>
        </div>
      }
    />
  );
};

export default RegistrationCompleted;
